import React, { Suspense, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import { ThemeProvider } from '@driftt/dds'
import { access } from '@driftt/traffic-control'

import Skeleton from 'components/Skeleton'
import { isRunningInDesktop } from 'config/platform'
import { registerWebAppServices } from 'notifications/services/webAppServices'
import { segmentTrack,TrackType } from 'utils/tracking'

import { getCurrentUser, getEnabledIntegrations,getOrgUsers } from '../../selectors'
import { ActivitiesPackageSubRoutes } from '../AccountActivity'

import '@driftt/react-dates/initialize'

import '@driftt/react-dates/lib/css/_datepicker.css'
import styles from '../AccountActivity/styles.module.css'

const getOrgUsersById = (users: any) =>
  users.reduce(
    (arr: any, user: any) => ({
      ...arr,
      [user.id]: user
    }),
    {}
  )

const App = () => {
  const orgUsers = useSelector(getOrgUsers)
  const currentUser = useSelector(getCurrentUser)
  const enabledIntegrations = useSelector(getEnabledIntegrations)

  const orgUsersById = getOrgUsersById(orgUsers)
  !isRunningInDesktop && registerWebAppServices()

  const hasProspector = access.isRbacUser()
    ? access.hasFeatures([{ featureName: 'prospector', accessLevel: 'READ' }])
    : access.hasGates(['prospector', 'has_account_activity'])
  const hasLiveView = access.isRbacUser()
    ? access.hasFeatures([{ featureName: 'prospector', accessLevel: 'READ' }])
    : access.hasGates('has_live_view')

  useEffect(() => {
    segmentTrack(TrackType.NEW_ACTIVITY_URL_ACCESSED)
  }, [])

  if (!hasProspector && hasLiveView) window.location.replace('/live')
  if (!hasProspector && !hasLiveView) window.location.replace('/conversations')

  return (
    <ThemeProvider>
      <Router basename="/">
        <div className={styles.app}>
          <Suspense fallback={<Skeleton />}>
            <div className={styles.routeContentContainer}>
              <Route
                path="/activity"
                render={props => (
                  <ActivitiesPackageSubRoutes
                    {...props}
                    orgUsersById={orgUsersById}
                    currentUser={currentUser}
                    enabledIntegrations={enabledIntegrations}
                    access={access}
                  />
                )}
              />
            </div>
          </Suspense>
        </div>
      </Router>
    </ThemeProvider>
  )
}

export default App
